import { render, staticRenderFns } from "./IntroPage.vue?vue&type=template&id=2b8e67a1"
import script from "./IntroPage.vue?vue&type=script&lang=js"
export * from "./IntroPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports